
import { AdminClassView } from './admin/AdminClassView'
import { TeacherClassView } from './teacher/TeacherClassView'

import { PersonaSwitcher } from '../../../components/PersonaSwitcher';

// --- Profile Component ---

const Class = () =>
    <PersonaSwitcher
        adminView={<AdminClassView />}
        //adminView={<TeacherClassView />}
        teacherView={<TeacherClassView />}
    />

export { Class };
